import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardActionArea, CardContent, Container, Grid, Typography } from '@mui/material';
import { Add, Group, LibraryAddCheck, Receipt } from '@mui/icons-material';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import { CurrencyExchange } from '@mui/icons-material';

import PageDefault from '../../components/PageDefault';
import { hasAnyRole } from '../../services/auth';

export default function Home() {
  const navigate = useNavigate();

  const shortcuts = [
    {
      title: 'Cobranças',
      description: 'Listar e gerenciar cobranças',
      icon: <Receipt />,
      to: '/cobrancas',
      roles: ['ADMIN', 'USER'],
    },
    {
      title: 'Contribuintes',
      description: 'Listar contribuintes',
      icon: <Group />,
      to: '/contribuintes',
      roles: ['ADMIN'],
    },
    {
      title: 'Imóveis',
      description: 'Listar imóveis',
      icon: <MapsHomeWorkIcon />,
      to: '/imoveis',
      roles: ['ADMIN', 'USER'],
    },
    {
      title: 'Pagamentos',
      description: 'Consultar pagamentos',
      icon: <CurrencyExchange />,
      to: '/pagamentos',
      roles: ['ADMIN'],
    },
    {
      title: 'Gerenciar Ruas',
      description: 'Cadastro e manutenção de ruas',
      icon: <Add />,
      to: '/gerenciar-ruas',
      roles: ['ADMIN'],
    },
    {
      title: 'Autenticar Certidão',
      description: 'Verificar se uma certidão é válida',
      icon: <LibraryAddCheck />,
      to: '/validar-certidao',
      roles: ['ADMIN', 'USER'],
    }
  ];

  const visibleShortcuts = shortcuts.filter((s) => hasAnyRole(s.roles));

  return (
    <PageDefault carregando={false} title="Início">
      <Container maxWidth="lg" sx={{ mb: 0 }}>
        <Grid container spacing={2}>
          {visibleShortcuts.map((s) => (
            <Grid item key={s.to} xs={12} sm={6} md={4}>
              <Card variant="outlined">
                <CardActionArea onClick={() => navigate(s.to)}>
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                      <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>{s.icon}</Box>
                      <Typography variant="h6">{s.title}</Typography>
                    </Box>
                    <Typography variant="body2" color="text.secondary">{s.description}</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </PageDefault>
  );
}